import App from "../App";
import About from "../pages/about";
import Error from "../pages/error";
import Fundapp from "../pages/fundapp";
import TraitApp from "../pages/trait";

export const RouteMap = [
  {
    path: "/",
    element: <App />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/404",
    element: <Error />,
  },
  {
    path: "/fundall",
    element: <Fundapp />,
  },
  {
    path: "/trait",
    element: <TraitApp />,
  },
];
